const setFlashFormData = (form, excludedFields = []) => {
  const formData = new FormData(form);
  [].concat(excludedFields).forEach(field => formData.delete(field));
  const jsonFormData = JSON.stringify(Object.fromEntries(formData.entries()));
  sessionStorage.setItem('flashFormData', jsonFormData);
};

const getFlashFormData = (form) => {
  const flashFormData = sessionStorage.getItem('flashFormData');
  if (flashFormData) {
    const formFields = JSON.parse(flashFormData);
    for (let elem in formFields) {
      form[elem].value = formFields[elem];
    }
    sessionStorage.removeItem('flashFormData');
  }
};

export {setFlashFormData, getFlashFormData};